export const HOME_PAGE = 'home_page';
export const INFO_PAGE = 'info_page';
export const CPU_PAGE = 'cpu_page';
export const RIPPLE_ADDER_PAGE = 'ripple_adder_page';
export const CLA_ADDER_PAGE = 'cla_adder_page';
export const GATES_PAGE = 'gates_page';
export const LATCHES_PAGE = 'latches_page';
export const RING_COUNTER_PAGE = 'ring_counter_page';
